import type { ExternalReportSettings } from '@/models/apis/externalReports/external_report_settings';
import type {
  HokkaidoAirportSettings,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportSettings';
import { EXTERNAL_REPORT_TYPE } from '@/consts/externalReports/hokkaidoAirport';

export const isHokkaidoAirportExternalReportSettings = (
  settings: ExternalReportSettings,
): settings is HokkaidoAirportSettings => {
  return !!settings && settings.external_report_type === EXTERNAL_REPORT_TYPE;
};

// 印刷画面の地図は MTX のある報告書にだけ生成されるため、地図の ref 配列は MTX のある報告書と順に対応する
export const pairPrintReportsWithMaps = <TReport extends { mtxsExt: unknown[] }, TMap>(
  reports: TReport[],
  maps: TMap[],
): Array<{ report: TReport; map: TMap }> => {
  const reportsWithMtxs = reports.filter(report => report.mtxsExt.length > 0);
  return reportsWithMtxs.slice(0, maps.length).map((report, idx) => ({ report, map: maps[idx] }));
};

const TRACK_VISIBILITY_QUERY_KEY = 'show_track';
const TRACK_HIDDEN_QUERY_VALUE = '0';

// 報告書モードの走行軌跡の表示状態を印刷画面の URL クエリで渡す。表示（既定）のときはクエリを付けない
export const buildTrackVisibilityQuery = (isTrackVisible: boolean): Record<string, string> => {
  if (isTrackVisible) return {};

  return { [TRACK_VISIBILITY_QUERY_KEY]: TRACK_HIDDEN_QUERY_VALUE };
};

export const parseTrackVisibilityQuery = (query: Record<string, unknown>): boolean => {
  return query[TRACK_VISIBILITY_QUERY_KEY] !== TRACK_HIDDEN_QUERY_VALUE;
};
